export default __webpack_public_path__ + "static/media/1901.886e37dc.png";